const actionTypes = {
  RECEIVE_PREMIUM_TRIALS: "seneca/premium-trials/RECEIVE_PREMIUM_TRIALS",
  STUDY_WRONG_ANSWER_SESSION: "seneca/premium-trials/STUDY_WRONG_ANSWER_SESSION"
};

export default actionTypes;
